import { clampTo, hasImageInput } from '../../tools';
import type { KieModelConfig } from '../types';

export const xaiConfigs: Record<string, KieModelConfig> = {
    'grok-imagine-image-2.0': {
        // https://docs.kie.ai/market/grok-imagine-image-2-0/text-to-image
        // https://docs.kie.ai/market/grok-imagine-image-2-0/image-to-image
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'grok-imagine-image-2-0/image-edit',
                    input: {
                        prompt: prompt,
                        aspect_ratio: aspectRatio === 'match'
                            ? 'auto'
                            : clampTo(aspectRatio || '1:1', ['1:1', '2:3', '3:2', '16:9', '9:16'] as const, '1:1'),
                        // 图片 URL
                        image_urls: image_urls!.slice(0, 5),
                    },
                };
            } else {
                return {
                    model: 'grok-imagine-image-2-0/text-to-image',
                    input: {
                        prompt: prompt,
                        aspect_ratio: clampTo(aspectRatio || '1:1', ['1:1', '2:3', '3:2', '16:9', '9:16'] as const, '1:1'),
                    },
                };
            }
        },
    },
};